import { render, staticRenderFns } from "./ServiceConfigI18n.vue?vue&type=template&id=80d3be8a&"
import script from "./ServiceConfigI18n.vue?vue&type=script&lang=js&"
export * from "./ServiceConfigI18n.vue?vue&type=script&lang=js&"
import style0 from "./ServiceConfigI18n.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports